import { useSelector } from 'react-redux';
import useCloud from '../../../cloud';
import { getToken } from 'firebase/app-check';
import { firebaseConfig, auth, appCheck } from '../../../../firebase';

const useCloudFunction = () => {
  const { callFunction } = useCloud();
  const user = useSelector(state => state.User);

  const callCloudFunction = async ({
    data,
    step,
    sequence,
    history,
    selections,
    documents,
    local
  }) => {
    let parameters = {};

    if (step.cloudFunctionDataCode?.trim().length > 0) {
      try {
        // eslint-disable-next-line
        const computeFunction = new Function(
          'step',
          'sequence',
          'history',
          'selections',
          'documents',
          'local',
          'user',
          'data',
          step.cloudFunctionDataCode
        );
        parameters = computeFunction(
          step,
          sequence,
          history,
          selections,
          documents,
          local,
          user,
          data
        );
      } catch (error) {
        return { error };
      }
    }

    let result;

    try {
      if (step.useOnRequest) {
        const appCheckTokenResponse = await getToken(
          appCheck
          /* forceRefresh= false*/
        );

        const headers = {
          'Content-Type': 'application/json',
          'X-Firebase-AppCheck': appCheckTokenResponse.token
        };

        let url = `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net/${step.cloudFunctionName}`;
        if (window.location.href.includes('localhost:')) {
          url = `http://127.0.0.1:5001/${firebaseConfig.projectId}/us-central1/${step.cloudFunctionName}`;
        }

        const currentUser = auth.currentUser;
        if (currentUser) {
          const idToken = await currentUser.getIdToken();
          headers['Authorization'] = `Bearer ${idToken}`;
        }

        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            data: {
              ...(parameters || {})
            }
          }),
          mode: 'cors'
        });

        result = await response.json();
        result = result?.data || result;
      } else {
        result = await callFunction(step.cloudFunctionName, parameters);
      }
    } catch (error) {
      return { error };
    }

    if (result.error) {
      return { error: result.error };
    }

    return result;
  };

  return {
    callCloudFunction
  };
};

export default useCloudFunction;
